import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';

import { TextinputComponent } from '../components/textinput/textinput.component';
import { RadioButtonComponent } from '../components/radiobutton/radiobutton.component';
import { TextareaComponent } from '../components/textarea/textarea.component';
import { FormsModule, NgForm } from '@angular/forms';
import { ChangeDetectorRef } from '@angular/core';
import { environment } from '../../environments/environment';
import { OrderEntryService } from '../../services/order-entry.service';
import { ActivatedRoute } from '@angular/router';
import { Dispatch, HistoryLogs } from '../order-entry/order-entry-model/order-entry.model';
import { TableComponent } from '../components/table/table.component';
import { Appconstants } from '../utils/appconstants';
import { Observable, of } from 'rxjs';
import { MessageService } from 'primeng/api';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { MyMonitoringService } from '../../services/logging.service';

@Component({
  selector: 'app-dispatch-data',
  imports: [FormsModule, TextinputComponent, RadioButtonComponent, TextareaComponent, TableComponent],
  providers: [MessageService, OrderEntryService],
  templateUrl: './dispatch-data.component.html',
  styleUrl: './dispatch-data.component.scss',
  standalone: true,
})

export class DispatchDataComponent {
  @ViewChild('tblConfig') tblConfig!: TableComponent;
  isTyping!: boolean;
  typingTimeout: any;
  historyLogsColumns: any[] = [];
  disabledispatchEntry: boolean = false;
  @Input() dispatch!: Dispatch | null;
  @Input() historyLogs$!: Observable<HistoryLogs[]>;
  @Input() totalNumRecords!: number;
  @ViewChild('dispatchData', { static: false }) dispatchDataForm!: NgForm;
  @Output() formStatusChange = new EventEmitter<boolean>();
  @Output() formValuesChange = new EventEmitter<any>();
  @Output() callerTypeChanged = new EventEmitter<string>();
  buildingIsRequired: boolean = false;
  isYesNo = [Appconstants.Yes, Appconstants.No];
  analystEntry = ['Entered', 'Pending', 'Failed Workflow', 'Order Processing Complete', 'Cancelled by Customer'];
  dispatchEntry = ['Pending', 'Dispatched', 'Tecod', 'Cancelled', 'Rescheduled'];
  dataInSapValue: string = '';
  sapWoValue: string = '';
  analystEntryValue: string = '';
  dispatchEntryValue: string = '';
  dispatchFirstNameValue: string = '';
  dispatchLastNameValue: string = '';
  dispatchTechIdValue: string = '';
  statusUpdateNotesValue: string = '';
  actionButtons: any = [];
  isWoRequired: boolean = false;
  isServiceTechRequired: boolean = false;
  isHistoryLogs: boolean = false;
  isEdit: boolean = false;
  pageSize: number = 10;
  totalRecords: number = 2000;
  currentPage: number = 1;
  isLoading: boolean = true;
  isSuccess: boolean = false;
  isFailure: boolean = false;
  processMessage: string = "";
  sortField: string = "";
  sortOrder: number = 1;
  searchText: any = "";

  constructor(private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private monotoringService: MyMonitoringService,
    private messageService: MessageService,
    private orderEntryService: OrderEntryService) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dispatch'] && changes['dispatch'].currentValue) {
      // Data is now available – initialize form or logic here
      if (this.dispatch) {
        this.dispatchFirstNameValue = this.dispatch.DispatchFirstName;
        this.sapWoValue = this.dispatch.SapWo;
        this.dispatchLastNameValue = this.dispatch.DispatchLastName;
        this.statusUpdateNotesValue = this.dispatch.StatusUpdateNotes;
        this.dispatchTechIdValue = this.dispatch.DispatchTechId;
        this.dataInSapValue = this.dispatch.DataInSap;
        this.analystEntryValue = this.dispatch.AnalystEntry;
        this.disabledispatchEntry = (this.analystEntryValue === 'Cancelled by Customer');
        this.dispatchEntryValue = this.dispatch.DispatchEntry;
        this.historyLogs$.subscribe((logs) => {
          if (logs.length > 0) {
            this.isHistoryLogs = true;
          }
        });
      }
      this.totalRecords = this.totalNumRecords;
    }
    this.emitFormValidity();
  }

  ngOnInit(): void {
    this.dataInSapValue = 'No';
    this.analystEntryValue = this.analystEntry[0];
    this.dispatchEntryValue = this.dispatchEntry[0];
    var ccrId = this.route.snapshot.paramMap.get('ccrId');
    if (ccrId != null) {
      this.isEdit = true;
      if (this.dispatch != null) {
        this.dispatchFirstNameValue = this.dispatch.DispatchFirstName;
      }
      this.historyLogsColumns = [
        { "field": "ReqestedDate", "header": "Date", "filter": true, "isSorting": true, "width": "5%" },
        { "field": "AnalystName", "header": "Analyst", "filter": true, "isSorting": true, "width": "5%" },
        { "field": "Action", "header": "Action", "filter": true, "isSorting": true, "width": "5%" },
      ];
    }
    this.emitFormValidity();
  }

  onDataInSapChange(selectedValue: string) {
    if (selectedValue == 'Yes') {
      this.isWoRequired = true;
    }
    else {
      this.isWoRequired = false;
    }
    this.dataInSapValue = selectedValue;
    this.emitFormValidity();
  }

  onSapWoChange(selectedValue: string) {
    this.sapWoValue = selectedValue;
    this.emitFormValidity();
  }

  onAnalystEntryChange(selectedValue: string) {
    this.analystEntryValue = selectedValue;
    if (selectedValue === 'Cancelled by Customer') {
      this.onDispatchEntryChange('Cancelled');
      this.disabledispatchEntry = true;
    }
    else {
      this.disabledispatchEntry = false;
    }
    this.emitFormValidity();
  }

  onDispatchEntryChange(selectedValue: string) {
    this.dispatchEntryValue = selectedValue;
    if (selectedValue == 'Dispatched' || selectedValue == 'Tecod') {
      this.isServiceTechRequired = true;
    }
    else {
      this.isServiceTechRequired = false;
    }
    this.emitFormValidity();
  }

  onDispatchFirstNameChange(selectedValue: string) {
    this.dispatchFirstNameValue = selectedValue;
    this.emitFormValidity();
  }

  onDispatchLastNameChange(selectedValue: string) {
    this.dispatchLastNameValue = selectedValue;
    this.emitFormValidity();
  }

  onDispatchTechIdChange(selectedValue: string) {
    this.dispatchTechIdValue = selectedValue;
    this.emitFormValidity();
  }

  onStatusUpdateNotesChange(selectedValue: string) {
    if (typeof selectedValue === 'string') {
      this.statusUpdateNotesValue = selectedValue;
      this.emitFormValidity();
    }
  }

  checkFormValidity() {
    const isValid = this.dispatchDataForm.valid ?? false;
    this.formStatusChange.emit(isValid);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.emitFormValidity();
    }, 0);
  }

  emitFormValidity() {
    setTimeout(() => {
      if (this.dispatchDataForm) {
        this.formStatusChange.emit(this.dispatchDataForm?.valid ?? false);
        this.formValuesChange.emit(this.dispatchDataForm.value);
      }
      this.cdr.detectChanges();
    });
  }

  onPageChanged(event: any): void {
    const pageSize = event.pageSize;
    const pageNumber = event.page;
    this.currentPage = pageNumber;
    this.pageSize = pageSize;
    this.loadHistoryLog();
  }

  reload() {
    this.tblConfig.clear();

  }

  onReloadClicked() {
    this.reload();
  }

  onCellClicked(event: any[]) {
  }

  onSearchText(event: any): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.currentPage = 1
    this.tblConfig.resetPage();
    this.searchText = event.searchText;
    this.loadHistoryLog();
  }

  onSortClicked(event: any): void {
    this.sortField = event.sortField;
    this.sortOrder = event.sortOrder;
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.loadHistoryLog();
  }

  loadHistoryLog(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    var ccrId = this.route.snapshot.paramMap.get('ccrId');
    const payload = {
      CcrId: ccrId,
      PageNumber: this.currentPage,
      PageSize: this.pageSize,
      SortField: this.sortField,
      SortOrder: this.sortOrder,
      SearchText: this.searchText
    }

    this.orderEntryService.getHistoryLogRecords(payload).subscribe({
      next: (data: any) => {
        const totalRec = data?.Payload?.TotalRecords;
        this.historyLogs$ = of(data?.Payload?.Data);
        this.isSuccess = true;
        //this.tblConfig.clear();
        //this.filteredData$ = of(updatedData);
        this.totalRecords = totalRec;
      },
      error: error => {
        this.isLoading = false;
        this.isFailure = true;
        const errMsg = environment.appMessages.ServerError;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'DispatchDataComponent.loadHistoryLog', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;
      }
    });
  }
}
export { HistoryLogs };

